const salary = [
    { id: 1, name: '1' },
    { id: 2, name: '2' },
    { id: 3, name: '3' },
    { id: 4, name: '4' },
    { id: 5, name: '5' },
    { id: 6, name: '6' },
    { id: 7, name: '7' },
    { id: 8, name: '8' },
    { id: 9, name: '9' },
    { id: 10, name: '10' },
    { id: 11, name: '11' },
    { id: 12, name: '12' },
    { id: 13, name: '13' },
    { id: 14, name: '14' },
    { id: 15, name: '15' },
    { id: 16, name: '16' },
    { id: 17, name: '17' },
    { id: 18, name: '18' },
    { id: 19, name: '19' },
    { id: 20, name: '20' },
    { id: 21, name: '21' },
    { id: 22, name: '22' },
    { id: 23, name: '23' },
    { id: 24, name: '24' },
    { id: 25, name: '25' },
    { id: 26, name: '26' },
    { id: 27, name: '27' },
    { id: 28, name: '28' },
    { id: 29, name: '29' },
    { id: 30, name: '30' },
    { id: 31, name: '31' },
    { id: 32, name: '32' },
    { id: 33, name: '33' },
    { id: 34, name: '34' },
    { id: 35, name: '35' },
    { id: 36, name: '36' },
    { id: 37, name: '37' },
    { id: 38, name: '38' },
    { id: 39, name: '39' },
    { id: 40, name: '40' },
    { id: 41, name: '41' },
    { id: 42, name: '42' },
    { id: 43, name: '43' },
    { id: 44, name: '44' },
    { id: 45, name: '45' },
    { id: 46, name: '46' },
    { id: 47, name: '47' },
    { id: 48, name: '48' },
    { id: 49, name: '49' },
    { id: 50, name: '50' },
    { id: 51, name: '51' },
    { id: 52, name: '52' },
    { id: 53, name: '53' },
    { id: 54, name: '54' },
    { id: 55, name: '55' },
    { id: 56, name: '56' },
    { id: 57, name: '57' },
    { id: 58, name: '58' },
    { id: 59, name: '59' },
    { id: 60, name: '60' },
    { id: 61, name: '61' },
    { id: 62, name: '62' },
    { id: 63, name: '63' },
    { id: 64, name: '64' },
    { id: 65, name: '65' },
    { id: 66, name: '66' },
    { id: 67, name: '67' },
    { id: 68, name: '68' },
    { id: 69, name: '69' },
    { id: 70, name: '70' },
    { id: 71, name: '71' },
    { id: 72, name: '72' },
    { id: 73, name: '73' },
    { id: 74, name: '74' },
    { id: 75, name: '75' },
    { id: 76, name: '76' },
    { id: 77, name: '77' },
    { id: 78, name: '78' },
    { id: 79, name: '79' },
    { id: 80, name: '80' },
    { id: 81, name: '81' },
    { id: 82, name: '82' },
    { id: 83, name: '83' },
    { id: 84, name: '84' },
    { id: 85, name: '85' },
    { id: 86, name: '86' },
    { id: 87, name: '87' },
    { id: 88, name: '88' },
    { id: 89, name: '89' },
    { id: 90, name: '90' },
    { id: 91, name: '91' },
    { id: 92, name: '92' },
    { id: 93, name: '93' },
    { id: 94, name: '94' },
    { id: 95, name: '95' },
    { id: 96, name: '96' },
    { id: 97, name: '97' },
    { id: 98, name: '98' },
    { id: 99, name: '99' },
    // { id: 100, name: '100' },
    // { id: 101, name: '100+'}
]

const salaryCrore = [
    { id: 100, name: '1' },
    { id: 101, name: '1.01' },
    { id: 110, name: '1.1' },
    { id: 120, name: '1.2' },
    { id: 130, name: '1.3' },
    { id: 140, name: '1.4' },
    { id: 150, name: '1.5' },
    { id: 160, name: '1.6' },
    { id: 170, name: '1.7' },
    { id: 180, name: '1.8' },
    { id: 190, name: '1.9' },
    { id: 200, name: '2' },
    { id: 210, name: '2.1' },
    { id: 220, name: '2.2' },
    { id: 230, name: '2.3' },
    { id: 240, name: '2.4' },
    { id: 250, name: '2.5' },
    { id: 260, name: '2.6' },
    { id: 270, name: '2.7' },
    { id: 280, name: '2.8' },
    { id: 290, name: '2.9' },
    { id: 300, name: '3' },
    { id: 310, name: '3.1' },
    { id: 320, name: '3.2' },
    { id: 330, name: '3.3' },
    { id: 340, name: '3.4' },
    { id: 350, name: '3.5' },
    { id: 360, name: '3.6' },
    { id: 370, name: '3.7' },
    { id: 380, name: '3.8' },
    { id: 390, name: '3.9' },
    { id: 400, name: '4' },
    { id: 410, name: '4.1' },
    { id: 420, name: '4.2' },
    { id: 430, name: '4.3' },
    { id: 440, name: '4.4' },
    { id: 450, name: '4.5' },
    { id: 460, name: '4.6' },
    { id: 470, name: '4.7' },
    { id: 480, name: '4.8' },
    { id: 490, name: '4.9' },
    { id: 500, name: '5' },
    { id: 510, name: '5.1' },
    { id: 520, name: '5.2' },
    { id: 530, name: '5.3' },
    { id: 540, name: '5.4' },
    { id: 550, name: '5.5' },
    { id: 560, name: '5.6' },
    { id: 570, name: '5.7' },
    { id: 580, name: '5.8' },
    { id: 590, name: '5.9' },
    { id: 600, name: '6' },
    { id: 610, name: '6.1' },
    { id: 620, name: '6.2' },
    { id: 630, name: '6.3' },
    { id: 640, name: '6.4' },
    { id: 650, name: '6.5' },
    { id: 660, name: '6.6' },
    { id: 670, name: '6.7' },
    { id: 680, name: '6.8' },
    { id: 690, name: '6.9' },
    { id: 700, name: '7' },
    { id: 710, name: '7.1' },
    { id: 720, name: '7.2' },
    { id: 730, name: '7.3' },
    { id: 740, name: '7.4' },
    { id: 750, name: '7.5' },
    { id: 760, name: '7.6' },
    { id: 770, name: '7.7' },
    { id: 780, name: '7.8' },
    { id: 790, name: '7.9' },
    { id: 800, name: '8' },
    { id: 810, name: '8.1' },
    { id: 820, name: '8.2' },
    { id: 830, name: '8.3' },
    { id: 840, name: '8.4' },
    { id: 850, name: '8.5' },
    { id: 860, name: '8.6' },
    { id: 870, name: '8.7' },
    { id: 880, name: '8.8' },
    { id: 890, name: '8.9' },
    { id: 900, name: '9' },
    { id: 910, name: '9.1' },
    { id: 920, name: '9.2' },
    { id: 930, name: '9.3' },
    { id: 940, name: '9.4' },
    { id: 950, name: '9.5' },
    { id: 960, name: '9.6' },
    { id: 970, name: '9.7' },
    { id: 980, name: '9.8' },
    { id: 990, name: '9.9' },
]

const salaryType = [
    { id: 'lakh', name: 'Lakhs' },
    { id: 'crore', name: 'Crores' }
]

const copyMinSalary = salary.slice();
copyMinSalary.unshift({ id:0, name: 'Min salary (in Lakhs)' })
export const minSalary = copyMinSalary;

const copyMaxSalary = salary.slice();
copyMaxSalary.unshift({ id:0, name: 'Max salary (in Lakhs)' });
export const maxSalary = copyMaxSalary;

const copyMinSalaryCrore = salaryCrore.slice();
copyMinSalaryCrore.unshift({ id:0, name: 'Min salary (in Crores)' })
export const minSalaryCrore = copyMinSalaryCrore;

const copyMaxSalaryCrore = salaryCrore.slice();
copyMaxSalaryCrore.unshift({ id:0, name: 'Max salary (in Crores)' });
export const maxSalaryCrore = copyMaxSalaryCrore;

export const salaryTypeData = salaryType;
